export default {
    title: '组件库 Components',
    routes: [
        {
            path: '/',
        },
    ]
};
